var React = require('react');

function FooterCurve1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M135.406 147.5C142.069 147.784 53.1246 129.951 69.4052 79.9998C91.4052 12.5 49.4052 2.5 25.9061 9.49982","stroke":"black","strokeWidth":"6","strokeLinecap":"round","strokeDasharray":"10 20"}));
}

FooterCurve1.defaultProps = {"width":"163","height":"140","viewBox":"0 0 163 140","fill":"none"};

module.exports = FooterCurve1;

FooterCurve1.default = FooterCurve1;
